export const DRIVER_CHAT_TOPIC_PREFIX = '/topic/driver-chat';

/** New-message notifications and ride-status changes for every dispatcher of a payor. */
export const driverChatPayorTopic = (payorId: number | string) =>
  `${DRIVER_CHAT_TOPIC_PREFIX}/payor/${payorId}`;

/** Live events for one open conversation; the server checks payor ownership. */
export const driverChatConversationTopic = (conversationId: number) =>
  `${DRIVER_CHAT_TOPIC_PREFIX}/conversation/${conversationId}`;

export const DRIVER_CHAT_MESSAGE_LIMIT = 500;
export const DRIVER_CHAT_COUNTER_THRESHOLD = 400;
/** Consecutive messages from one sender within this window share a group. */
export const DRIVER_CHAT_GROUP_WINDOW_MS = 3 * 60 * 1000;
export const DRIVER_CHAT_MESSAGES_PAGE_SIZE = 50;

/** Fallback only; the real list comes from GET /driver-chat/quick-replies. */
export const DRIVER_CHAT_QUICK_REPLIES = [
  'Patient is ready',
  'Use the main entrance',
  "What's your ETA?",
  'Wheelchair assistance needed',
  'Please call the patient',
];

export const DRIVER_CHAT_IN_PROGRESS_GROUP = 'In progress';

// Generic on purpose: toasts must never carry message text or member details.
export const DRIVER_CHAT_TOAST_TITLE = 'New message from driver';
